import { computed } from "vue";
function useElevationProp() {
  const ELEVATIONS = ["", "low", "medium", "high", "ultra"];
  function createElevationProp(type = String, defaultValue = "") {
    if (type === String) {
      return {
        elevation: {
          type,
          default: defaultValue,
          validator: (elevation) => ELEVATIONS.includes(elevation)
        }
      };
    }
    return {
      elevation: {
        type,
        default: defaultValue
      }
    };
  }
  function getElevationBoxShadow(props) {
    const boxShadowOptions = {
      low: "var(--shadow-small)",
      medium: "var(--shadow-medium)",
      high: "var(--shadow-large)",
      ultra: "var(--shadow-large-x)"
    };
    const boxShadow = computed(() => ({
      boxShadow: boxShadowOptions[props.elevation]
    }));
    return { boxShadowOptions, boxShadow };
  }
  return {
    ELEVATIONS,
    createElevationProp,
    getElevationBoxShadow
  };
}
export {
  useElevationProp as u
};
